import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=0170f8ba&scoped=true&"
import script from "./CancelButton.vue?vue&type=script&lang=ts&"
export * from "./CancelButton.vue?vue&type=script&lang=ts&"
import style0 from "./CancelButton.vue?vue&type=style&index=0&id=0170f8ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170f8ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
